import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { keyframes } from '@stylexjs/stylex';
import * as stylex from '@stylexjs/stylex';

const skeletonLoading = keyframes({
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
});

export const styles = stylex.create({
  container: {
    fontFamily: fonts.din2014Regular,
    position: 'relative',
    height: 'auto',
    backgroundColor: colors.deepBackground,
    borderRadius: anatomy.borderRadiusM,
    paddingRight: anatomy['size-8'],
    paddingBottom: anatomy['size-8'],
    paddingLeft: anatomy['size-8'],
  },
  skeletonLoading: {
    height: '68px',
    marginBottom: anatomy['size-4'],
    borderRadius: anatomy.borderRadiusS,
    background: `linear-gradient(90deg, ${colors.tertiaryBackground} 25%, ${colors.ghostBackground} 50%, ${colors.tertiaryBackground} 75%)`,
    backgroundSize: '200% 100%',
    animationName: skeletonLoading,
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
  scrollArea: {
    position: 'relative',
  },
  scrollButtons: {
    position: 'sticky',
    top: '546px',
    left: 0,
    right: 0,
    zIndex: 10,
  },
  scrollButton: {
    position: 'absolute',
    left: '-8px',
    padding: `${anatomy['space-24']} ${anatomy['space-12']}`,
    paddingLeft: 0,
    backgroundColor: colors.activeBackground,
    borderRadius: `0 60px 60px 0`,
    display: 'flex',
    color: colors.foregroundTertiary,
    ':hover': {
      backgroundColor: `rgba(174, 149, 95, 0.2)`,
      color: colors.accentText,
    },
    ':active': {
      backgroundColor: colors.brandBackground,
      color: colors.accentText,
    },
  },
  scrollButtonRight: {
    left: 'auto',
    right: '-8px',
    rotate: '180deg',
  },
});
